export enum JoistPlacement {
  RIM = "RIM",
  FLOOR = "FLOOR",
  NOGGIN = "NOGGIN",
}
